import { render } from "./VoronoiRendererConfig.vue?vue&type=template&id=225fdf36"
import script from "./VoronoiRendererConfig.vue?vue&type=script&lang=js"
export * from "./VoronoiRendererConfig.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__